import React from "react";
import { Dropdown, Navbar, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLanguageContext } from "../contexts/LanguageContext";
import "../../stylesheets/dropdown.css";
import {
  BoxArrowRight as LogoutIcon,
  PersonLinesFill as AccountIcon,
  Translate as LanguageIcon,
  Gear as SettingsIcon,
} from "react-bootstrap-icons";
function LanguageItem({ language, code }) {
  const { t, i18n } = useTranslation();
  const { setLanguage } = useLanguageContext();
  return (
    <NavDropdown.Item
      onClick={() => {
        setLanguage(code);
        localStorage.setItem("lang", code);
      }}
    >
      {language}
    </NavDropdown.Item>
  );
}

function LanguageSelector() {
  const { t, i18n } = useTranslation();

  return (
    <div className="dropdown-item-list">
      {/* <i>
        <LanguageIcon />
      </i>
      <div>
        <NavDropdown
          className="adminDrop disbleSelection innerDropdown"
          title={t("currentLang")}
        >
          <LanguageItem language={t("ar")} code={"ar"} />
          <LanguageItem language={t("en")} code={"en"} />
        </NavDropdown>
      </div> */}
    </div>
  );
}

function UserFragment() {
  const auth = useSelector((state) => state.auth);
  const user = auth?.user;
  console.log(user);
  return (
    <div className="userFragment">
      <h4>{user.name}</h4>
      <h6>{user.email}</h6>
    </div>
  );
}

export default function DropDownMenu({ logout }) {
  const { t, i18n } = useTranslation();
  return (
    <Dropdown
      // className="adminDrop disbleSelection"
      className="my-dropdown-toggle mainDropDown"
      title={t("settings")}
    >
      <Dropdown.Toggle variant="link" bsPrefix="p-0" className="mainToggle">
        <div>
          <SettingsIcon className="settingsIcon" />
        </div>
      </Dropdown.Toggle>

      <Dropdown.Menu className="">
        <UserFragment />

        {/* <NavDropdown.Item className="disbleSelection">
          <AccountIcon />
          {t("accSettings")}
        </NavDropdown.Item> */}
        <LanguageSelector />

        <NavDropdown.Item onClick={logout} className="disbleSelection">
          <LogoutIcon />
          {t("logout")}
        </NavDropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
